import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaUsuarioResponse } from '../../responses/usuario/lista-usuario.response';
import { ListaUsuarioEmpresaGroupResponse } from '../../responses/usuario/list-usuario-empresa-grupo.response';

@Injectable({
  providedIn: 'root',
})
export class UsuarioAdminService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(idEmpresa: number): Observable<ListaUsuarioResponse> {
    const uri: string = `UsuarioAdmin/empresa/${idEmpresa}`;

    return this.httpClient
      .get<ListaUsuarioResponse>(environment.urlApiUsuario + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public post(listaIDUsuario: number[]): Observable<ListaUsuarioResponse> {
    return this.httpClient
      .post<ListaUsuarioResponse>(
        environment.urlApiUsuario + `UsuarioAdmin/`,
        listaIDUsuario,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public getAllByListIdEmpresa(listIdEmpresa: number[], listarTodos: boolean): Observable<ListaUsuarioEmpresaGroupResponse> {
    return this.httpClient
      .post<ListaUsuarioEmpresaGroupResponse>(
        environment.urlApiUsuario + `UsuarioAdmin/listAllByListEmpresa?listarTodos=${listarTodos}`, listIdEmpresa,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
